class ReadMoreDescription extends window.BAO.CustomElement() {
    static get requiredElements () {
      return ['trigger', 'content']
    }
  
    connectedCallback () {
      super.connectedCallback()
      this.setInitialHeight()
    }
  
    setupListeners () {
      super.setupListeners()
      this.listeners.add(
        this.els.trigger.element,
        'click',
        this.handleClick.bind(this),
      )
    }
  
    handleClick (event) {
      if (this.isExpanded) {
        this.els.content.element.setAttribute('aria-expanded', 'false')
        this.els.trigger.element.textContent = this.dataset.readMoreTranslationReadMore
      } else {
        this.els.content.element.setAttribute('aria-expanded', 'true')
        this.els.trigger.element.textContent = this.dataset.readMoreTranslationReadLess
      }
    }
  
    setInitialHeight () {
      const contentStyle = getComputedStyle(this.els.content.element)
  
      let lineHeight = parseFloat(contentStyle.lineHeight)
  
      let marginBottom = 0
      const listItems = this.els.content.element.querySelectorAll('li')
  
      listItems.forEach((li, index) => {
        if (index < 3) {
          lineHeight = parseFloat(getComputedStyle(li).lineHeight)
          marginBottom += parseFloat(getComputedStyle(li).marginBottom)
        }
      })
  
      this.initialHeight = lineHeight * 3.75 + marginBottom
      if (!this.isExpanded) {
        this.els.content.element.style.setProperty(
          '--cutoff',
          `${this.initialHeight}px`,
        )
      }
    }
  
    get isExpanded () {
      return this.els.content.element.getAttribute('aria-expanded') === 'true'
    }
  }
  
  if (!customElements.get('read-more-description')) {
    customElements.define('read-more-description', ReadMoreDescription)
  }
  